import { useRef } from "react";
import uuid4 from "uuid4";

export const createUid = (): string => uuid4();

export const useUid = (): string => {
  const uidRef = useRef<string>(createUid());
  return uidRef.current;
};
